<script>
import dayjs from 'dayjs';
import {
  pageTitleMixin,
  prefetchDataMixin,
} from '@ubic/vue-mixins';
import { permissions } from '@/constants';
import ErrorAccessDenied from '@/components/ErrorAccessDenied';
import DateRangeSelect from '@/components/DateRangeSelect';
import IconFileDownload from '@/components/icons/FileDownload';
import ProjectDepartmentsHistory from './components/ProjectDepartmentsHistory';
import ProjectDepartments from './components/ProjectDepartments';
import ProjectSummary from './components/ProjectSummary';
import ProjectWorkers from './components/ProjectWorkers';
import service from './service';

export default {
  pageTitle: 'Статистика проекта',
  async prefetchData () {
    const { id } = this.$route.params;

    this.isFetching = true;

    this.filter = {
      ...this.filter,
      ...this.$route.query,
    };

    this.info = await service.projectInfo(id);

    this.isFetching = false;
  },
  mixins: [
    pageTitleMixin,
    prefetchDataMixin,
  ],
  data () {
    return {
      isFetching: false,
      info: {},

      filter: {
        minDate: dayjs().subtract(7, 'day').format('YYYY-MM-DD'),
        maxDate: dayjs().format('YYYY-MM-DD'),
      },
    };
  },
  computed: {
    hasReadPermission () {
      return this.$store
        .getters['auth/checkPermission'](permissions.STATISTICS_READ);
    },
    id () { return this.$route.params.id; },
    fetchSummary () {
      return filter => service.projectSummary(this.id, filter);
    },
    fetchDepartmentsHistory () {
      return filter => service.projectDepartmentsHistory(this.id, filter);
    },
    departmentsService () {
      return filter => service.projectDepartments(this.id, filter);
    },
    fetchWorkers () {
      return filter => service.projectWorkers(this.id, filter);
    },

    logsExportLink () {
      const { id } = this;
      const { minDate, maxDate } = this.filter;
      return `/logs/export?&project=${id}&minDate=${minDate}&maxDate=${maxDate}`;
    },
  },
  methods: {
    handleDateRangeChange (dates) {
      this.filter = {
        ...this.filter,
        ...dates,
      };

      this.updateQueryString();
    },
    updateQueryString () {
      this.$router.replace({
        ...this.$route,
        query: { ...this.filter },
      });
    },
  },
  render () {
    if (!this.hasReadPermission) {
      return (
        <ErrorAccessDenied />
      );
    }

    const { $style, filter } = this;

    return (
      <main>
        <header class="page-header">
          <u-title>
            <span>
              {this.info.name}
            </span>
            <span slot="sub">
              &nbsp;
              статистика
            </span>
          </u-title>

          <DateRangeSelect
            class="m-l-auto"
            value={this.filter}
            onChange={this.handleDateRangeChange}
          />
          <router-link
            to={this.logsExportLink}
            class="u-btn u-btn_outline u-btn_primary u-btn_square"
            style={{ marginLeft: '.5em' }}
          >
            <IconFileDownload />
          </router-link>
        </header>

        <section>
          <ProjectSummary
            filter={filter}
            dataService={this.fetchSummary}
          />
        </section>

        <section>
          <ProjectDepartmentsHistory
            filter={filter}
            fetchHistory={this.fetchDepartmentsHistory}
          />
        </section>

        <section>
          <u-title level="2">
            Сотрудники и департаменты
          </u-title>

          <div class={$style.row}>
            <div class={$style.col}>
              <ProjectWorkers
                filter={filter}
                fetchWorkers={this.fetchWorkers}
              />
            </div>
            <div class={$style.col}>
              <ProjectDepartments
                filter={filter}
                dataService={this.departmentsService}
              />
            </div>
          </div>
        </section>
      </main>
    );
  },
};
</script>

<style lang="scss" module>
.row {
  display: flex;
  margin: 0 -1em;
}

.col {
  display: flex;
  flex-direction: column;
  padding: 0 1em;
  width: 50%;
}
</style>
